var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 58.6663C17.2717 58.6663 5.33301 46.7277 5.33301 31.9997C5.33301 17.2717 17.2717 5.33301 31.9997 5.33301C46.7277 5.33301 58.6663 17.2717 58.6663 31.9997C58.6663 46.7277 46.7277 58.6663 31.9997 58.6663ZM31.9997 53.333C37.6576 53.333 43.0838 51.0854 47.0846 47.0846C51.0854 43.0838 53.333 37.6576 53.333 31.9997C53.333 26.3417 51.0854 20.9155 47.0846 16.9147C43.0838 12.914 37.6576 10.6663 31.9997 10.6663C26.3417 10.6663 20.9155 12.914 16.9147 16.9147C12.914 20.9155 10.6663 26.3417 10.6663 31.9997C10.6663 37.6576 12.914 43.0838 16.9147 47.0846C20.9155 51.0854 26.3417 53.333 31.9997 53.333ZM29.341 42.6663L18.0263 31.3517L21.797 27.581L29.341 35.125L44.4237 20.0397L48.197 23.8103L29.341 42.6663Z",
    fill: "#13B32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.3395949e17744db8135d111434914d82.svg";
export { ForwardRef as ReactComponent };